/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { ShipmentDetailsUI } from "@innofulfill/hubops-shipment-tracking";
import { useLocation, useNavigate } from "react-router-dom";
import "@innofulfill/hubops-shipment-tracking/dist/assets/hubops-shipment-tracking.css";
import urls from "../../api/urls";
function ShipmentDetails() {
  const location = useLocation();
  const { GET_SHIPMENT_TRACKING } = urls;
  const params = new URLSearchParams(location.search);
  const awbNumber = params.get("awb") || params.get("awbNumber") || "";
  return (
    <ShipmentDetailsUI endpoint={GET_SHIPMENT_TRACKING} awbNumber={awbNumber} />
  );
}

export default ShipmentDetails;


